// extracted by mini-css-extract-plugin
export default {"gallery":"c-q_fn","gallery__header":"c-q_fo","gallery__thumbs":"c-q_fp"};